import React, { FC } from 'react'
import { SelectPopup, SelectPopupProps } from '../SelectPopup'
import DropdownItem from './DropdownItem'
import DropdownListContainer from './DropdownListContainer'
import DropdownTitle from './DropdownTitle'

export interface IDropdownMenu extends SelectPopupProps {
  title: string
  showIcon?: boolean
}

const DropdownMenu: FC<IDropdownMenu> = ({
  title,
  showIcon = false,
  contentStyle,
  ...props
}) => {
  return (
    <SelectPopup
      {...props}
      trigger={
        <DropdownTitle
          title={title}
          showIcon={showIcon}
          selected={props.selected}
          disabled={props.disabled}
        />
      }
      itemTemplate={DropdownItem}
      listElementTemplate={DropdownListContainer}
      contentStyle={{ width: 150, padding: 10, ...contentStyle }}
      position='bottom right'
      closeOnSelect={true}
    />
  )
}

export default DropdownMenu
